import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ConsultationTypes = ({ onTypeSelect, selectedType }) => {
  const consultationTypes = [];

  if (consultationTypes?.length === 0) {
    return (
      <section className="py-16 lg:py-24 bg-muted">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="font-playfair text-3xl lg:text-4xl font-bold text-primary mb-4">
              Serviços Disponíveis
            </h2>
            <p className="text-xl text-text-secondary max-w-3xl mx-auto">
              Entre em contato conosco para mais informações sobre nossos serviços
            </p>
          </div>

          <div className="text-center">
            <div className="bg-card rounded-2xl p-12 border border-border">
              <Icon name="Info" size={48} className="mx-auto mb-4 text-primary" />
              <h3 className="font-playfair text-2xl font-semibold text-primary mb-4">
                Consultorias Temporariamente Indisponíveis
              </h3>
              <p className="text-text-secondary mb-6">
                Nossos serviços de consultoria estão sendo atualizados. Entre em contato conosco diretamente para atendimento personalizado.
              </p>
              <Button variant="default" iconName="Phone" iconPosition="left">
                Falar Conosco
              </Button>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-16 lg:py-24 bg-muted">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-playfair text-3xl lg:text-4xl font-bold text-primary mb-4">
            Escolha o Tipo de Consultoria
          </h2>
          <p className="text-xl text-text-secondary max-w-3xl mx-auto">
            Oferecemos diferentes modalidades de atendimento para se adequar às suas necessidades e preferências
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {consultationTypes?.map((type) => (
            <div
              key={type?.id}
              className={`relative bg-card rounded-2xl p-8 border-2 transition-all duration-300 cursor-pointer hover:shadow-premium ${
                selectedType === type?.id
                  ? 'border-primary shadow-premium'
                  : 'border-border hover:border-primary/50'
              }`}
              onClick={() => onTypeSelect(type?.id)}
            >
              {type?.popular && (
                <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
                  <span className="bg-accent text-accent-foreground px-4 py-1 rounded-full text-sm font-semibold">
                    Mais Popular
                  </span>
                </div>
              )}

              <div className="text-center mb-6">
                <div className={`w-16 h-16 mx-auto mb-4 rounded-2xl flex items-center justify-center ${
                  selectedType === type?.id ? 'bg-primary' : 'bg-primary/10'
                }`}>
                  <Icon 
                    name={type?.icon} 
                    size={32} 
                    color={selectedType === type?.id ? 'white' : 'var(--color-primary)'} 
                  />
                </div>
                <h3 className="font-playfair text-2xl font-semibold text-primary mb-2">
                  {type?.title}
                </h3>
                <p className="text-text-secondary leading-relaxed">
                  {type?.description}
                </p>
              </div>

              <div className="space-y-4 mb-6">
                <div className="flex items-center justify-between text-sm">
                  <span className="text-text-secondary">Duração:</span>
                  <span className="font-semibold text-primary">{type?.duration}</span>
                </div>
                <div className="flex items-center justify-between text-sm">
                  <span className="text-text-secondary">Local:</span>
                  <span className="font-semibold text-primary">{type?.location}</span>
                </div>
              </div>

              <div className="space-y-3 mb-8">
                {type?.benefits?.map((benefit, index) => (
                  <div key={index} className="flex items-center space-x-3">
                    <Icon name="CheckCircle" size={16} color="var(--color-success)" />
                    <span className="text-sm text-text-primary">{benefit}</span>
                  </div>
                ))}
              </div>

              <Button
                variant={selectedType === type?.id ? "default" : "outline"}
                fullWidth
                iconName={selectedType === type?.id ? "CheckCircle" : "ArrowRight"}
                iconPosition="right"
                className={selectedType === type?.id ? "bg-primary" : ""}
              >
                {selectedType === type?.id ? 'Selecionado' : 'Selecionar'}
              </Button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ConsultationTypes;